import { GenerateRecord, RecordStage } from "@hg/recall-frame"
import cls from "classnames"
import React, { Dispatch, FC, useMemo, useRef } from "react"

import { sfx } from "@/assets/audios/sfx"
import OutlinedText from "@/components/OutlinedText"
import { i18n } from "@/i18n"
import { Award } from "./Award"
import { Encode } from "./Encode"

import styles from "./index.module.scss"

interface SwitcherRef {
    setCurrent: Dispatch<RecordStage>
}

export const Record: FC = () => {
    const switcherRef = useRef<SwitcherRef | null>(null)

    return (
        <GenerateRecord
            wrapperCls={styles.recordPage}
            headerCls={styles.header}
            contentCls={styles.content}
            renderSwitcher={({ current, setCurrent }) => (
                <Switcher ref={switcherRef} {...{ current, setCurrent }} />
            )}
            renderAward={() => <Award />}
            renderEncode={() => <Encode switcherRef={switcherRef} />}
        />
    )
}

interface SwitcherProps {
    current: RecordStage
    setCurrent: Dispatch<RecordStage>
}

const Switcher = React.forwardRef<SwitcherRef, SwitcherProps>(
    ({ current, setCurrent }, ref) => {
        React.useImperativeHandle(ref, () => ({
            setCurrent,
        }))
        const awardTitle = useMemo(() => {
            return i18n.getRecall("record.switcher_award") || "-"
        }, [])
        const encodeTitle = useMemo(() => {
            return i18n.getRecall("record.switcher_encode") || "-"
        }, [])
        const textStyle = useMemo(() => {
            const base = {
                fontSize: 26,
                strokeWidth: 6,
                fillColor: "#fff",
            }
            return {
                left: {
                    ...base,
                    strokeColor: current === "award" ? "#917356" : "#1D585D",
                },
                right: {
                    ...base,
                    strokeColor: current === "encode" ? "#917356" : "#1D585D",
                },
            }
        }, [current])

        return (
            <>
                <div className={cls(styles.switcher, styles[current])}>
                    <div
                        className={cls(styles.awardBar)}
                        onClick={() => {
                            sfx.play("click")
                            setCurrent("award")
                        }}
                    >
                        <OutlinedText
                            className={styles.outlinedText}
                            text={awardTitle}
                            {...textStyle.left}
                        />
                    </div>
                    <div
                        className={cls(styles.encodeBar)}
                        onClick={() => {
                            sfx.play("click")
                            setCurrent("encode")
                        }}
                    >
                        <OutlinedText
                            className={styles.outlinedText}
                            text={encodeTitle}
                            {...textStyle.right}
                        />
                    </div>
                </div>
                <div className={styles.split}></div>
            </>
        )
    }
)
